import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import StarRatings from 'react-star-ratings';
import './StaffinoWidget.scss';
var StaffinoWidget = function (props) {
    var initial_data = useSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.domain) === null || _a === void 0 ? void 0 : _a.arbitrary) === null || _b === void 0 ? void 0 : _b.initial_data; });
    var handleSubmit = props.handleSubmit, handleCancel = props.handleCancel;
    var _a = useState(false), show = _a[0], setShow = _a[1];
    var _b = useState(false), kind = _b[0], setKind = _b[1];
    var _c = useState(), firstTime = _c[0], setFirstTime = _c[1];
    var _d = useState(0), rating = _d[0], setRating = _d[1];
    var setShowRestOfForm = function (showPositive) {
        setKind(showPositive);
        setShow(true);
    };
    var initialValues = {
        kind: '',
        firstTime: '',
        text: '',
        stars: null,
    };
    var validate = function (values) {
        var errors = {};
        if (values.text.trim().length < 1 && !kind) {
            errors.text = 'Povinné';
        }
        // mandatory for both kind and !kind
        if (typeof values.firstTime !== 'boolean') {
            errors.firstTime = 'Povinné';
        }
        // mandatory for both kind and !kind
        if (!values.stars) {
            errors.stars = 'Povinné';
        }
        return errors;
    };
    // "venue": {"reference": "sazka-deh"} by default (e.g. "https://www.sazka.cz" or
    // "https://sazka.cz/sazka-klub"), "sazka-sk-uat" for "https://uat.sazkahry.sk",
    // "sazka-sk" for "https://sazkahry.sk", "sazka-uat" for "https://uat.sazka.cz",
    // "sazka-lb" for "https://extranet.sazka.cz"
    var getVenue = function (location) {
        if (!location)
            return 'location is not defined';
        var venue = 'sazka-deh';
        if (location.includes('uat.sazkahry.sk'))
            venue = 'sazka-sk-uat';
        else if (location.includes('sazkahry.sk'))
            venue = 'sazka-sk';
        else if (location.includes('uat.sazka.cz'))
            venue = 'sazka-uat';
        else if (location.includes('extranet.sazka.cz'))
            venue = 'sazka-lb';
        return venue;
    };
    var formik = useFormik({
        initialValues: initialValues,
        validate: validate,
        onSubmit: function (_a) {
            var kind = _a.kind, text = _a.text, first = _a.firstTime, stars = _a.stars;
            var payload = {
                kind: kind ? 'thank-you' : 'suggestion',
                text: text,
                venue: { reference: getVenue(initial_data.Location) },
                answers: [],
            };
            first !== '' &&
                payload.answers.push({
                    question_id: '41906787-584e-438d-a157-1cc24b817c39',
                    choices: [
                        {
                            choice_id: first
                                ? '5c2fb8b6-8e03-4831-9f56-7b25288d4abe'
                                : 'cf0784ac-874f-48b8-b284-1ccf8588bf68',
                        },
                    ],
                });
            stars !== null &&
                payload.answers.push({
                    question_id: '1bcaa030-41c0-40c9-8092-63b6d1bcdd76',
                    score: stars,
                });
            handleSubmit(payload);
        },
    });
    var setStars = function (value) {
        setRating(value);
        formik.values.stars = value;
    };
    var setFirstTimeValue = function (e, value) {
        values.firstTime = value;
        setFirstTime(value);
        handleChange(e);
        validateForm();
    };
    var errors = formik.errors, values = formik.values, handleChange = formik.handleChange, validateForm = formik.validateForm, submitForm = formik.submitForm, resetForm = formik.resetForm, isSubmitting = formik.isSubmitting, setErrors = formik.setErrors;
    var _renderRestOfForm = function () {
        var textareaPlaceholder = 'Napíšte nám, prosím, aká bola vaša skúsenosť.';
        if (!show)
            return null;
        return (React.createElement("div", { className: "center flex column" },
            React.createElement("div", { className: "mb-24 mt-8 flex column" },
                React.createElement("textarea", { placeholder: textareaPlaceholder, value: values.text, name: "text", id: "text", onChange: handleChange, className: errors.text && 'error' }),
                errors.text && React.createElement("span", { className: "error" }, errors.text)),
            React.createElement("div", { className: "mb-24 first-time" },
                React.createElement("p", { className: "mb-8" }, "Bola Va\u0161a po\u017Eiadavka vyrie\u0161en\u00E1 na prv\u00FDkr\u00E1t?"),
                React.createElement("div", { className: "flex" },
                    React.createElement("div", { className: "mr-8" },
                        React.createElement("button", { className: "btn ".concat(firstTime && 'selected'), onClick: function (e) { return setFirstTimeValue(e, true); } },
                            React.createElement(LikeIcon, { selected: !!firstTime }),
                            "\u00C1no")),
                    React.createElement("div", null,
                        React.createElement("button", { className: "btn dislike ".concat(firstTime === false && 'selected'), onClick: function (e) { return setFirstTimeValue(e, false); } },
                            React.createElement(LikeIcon, { dislike: true, selected: firstTime === false }),
                            "Nie"))),
                errors.firstTime && (React.createElement("div", null,
                    React.createElement("span", { className: "error" }, errors.firstTime)))),
            React.createElement("p", { className: "mb-8" }, "Ako ste bol/a spokojen\u00FD/\u00E1 s pr\u00EDstupom \u0161pecialistu?"),
            React.createElement("div", { className: "mb-24" },
                React.createElement(StarRatings, { rating: rating, starRatedColor: "#000862", starHoverColor: "#000862", starEmptyColor: "none", starDimension: "24px", onChange: function (e) {
                        handleChange(e);
                        validateForm();
                    }, changeRating: function (newRating) {
                        setStars(newRating);
                        validateForm();
                    }, numberOfStars: 5, name: "rating" }),
                React.createElement("br", null),
                errors.stars && React.createElement("span", { className: "error" }, errors.stars)),
            React.createElement("button", { type: "submit", disabled: isSubmitting, className: "btn btn-submit", onClick: function (e) {
                    e.preventDefault();
                    if (validateForm(values))
                        submitForm();
                } }, "Odosla\u0165 dotazn\u00EDk")));
    };
    return (React.createElement("form", { className: "staffino-widget flex center column", onSubmit: function (e) {
            e.preventDefault();
        } },
        React.createElement("h5", { className: "mt-24" },
            "Ak\u00E1 bola sk\u00FAsenos\u0165 s na\u0161\u00EDm ",
            React.createElement("br", null),
            "\u0161pecialistom?"),
        React.createElement("div", { className: "flex mt-16 mb-16" },
            React.createElement("button", { className: "btn mr-8 ".concat(kind && 'selected'), onClick: function () {
                    setErrors({});
                    values.kind = true;
                    setShowRestOfForm(true);
                } }, "Chcem pochv\u00E1li\u0165"),
            React.createElement("button", { className: "btn ".concat(!kind && show && 'selected'), onClick: function () {
                    values.kind = false;
                    setShowRestOfForm(false);
                } }, "M\u00E1m pripomienku")),
        _renderRestOfForm(),
        React.createElement("button", { className: "cancel", onClick: function () {
                resetForm();
                handleCancel();
            } }, "Zavrie\u0165 chat bez hodnotenia")));
};
var LikeIcon = function (_a) {
    var _b = _a.dislike, dislike = _b === void 0 ? false : _b, _c = _a.selected, selected = _c === void 0 ? false : _c;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", version: "1.0", viewBox: "0 0 442 407", fill: selected ? 'white' : '#000862', transform: dislike ? 'scale(1 -1)' : '' },
        React.createElement("path", { d: "M254 22.7c-6.3 1.1-10.1 2.6-13 5-5.5 4.5-7.1 9.2-8.6 24.8-.7 7.9-1.8 16.5-2.5 19.1-3.3 13.8-11.8 24.9-28.6 37.5-32 24-49.6 44-64.7 73.6-6.5 12.7-11.1 17.6-18.1 19.4-2.7.7-5.4 2.2-6.5 3.7-2 2.4-2 4.3-2 82.4 0 84.9 0 85.2 4.7 87.6 2.5 1.4 6.1 1.8 38.8 5.2 64 6.5 82.8 7.4 124 6 35.9-1.2 47-2.6 56.1-7 9.9-4.8 13.8-12.1 16.8-30.9l1.5-9.4 7.4-7.1c9.6-9.3 12.2-14.6 12.2-24.7 0-6.7-.4-8.3-3.9-15.3l-3.8-7.8 6.5-6.7c13.2-13.3 13.8-22.5 2.7-41.2l-4-6.7 4.1-9.1c5.5-12.6 6.6-18.3 5.1-27.1-2.2-12.8-7.2-19.9-17.2-24.3-14.2-6.3-28.5-7.8-68.7-7.5l-31.1.3-2.6-2.4c-5.1-4.8-3.8-9.2 15.3-51.3 9.1-20 11.5-29.6 10.9-43.3-.8-15.6-7.9-34.5-15.1-39.6-2.5-1.8-9.3-4-11.7-3.8-.8.1-2.6.4-4 .6zM37.5 203.1c-4.7 2.6-4.5-.4-4.5 87.9v83.7l2.6 2.4c2.6 2.4 2.6 2.4 28.2 2.7 28 .3 31.3.1 34.3-2.9 1.9-1.9 1.9-4 1.9-85.8 0-81.1-.1-84-1.9-86.2l-1.9-2.4-28.4-.2c-19.4-.2-28.9.1-30.3.8z" })));
};
export default StaffinoWidget;
